/** `month` is `YYYY-MM`. */
export const usersDayStatesEndpoint = (userId: string, month: string) => `/users/${userId}/time-trackings/${month}/day-states`;
